import { Box, Typography } from "@mui/material"
import { sanitizeAmendsHtml } from "authoring/routes/project/amends/lib/sanitize-amends-html"
import { hasAmendsContent } from "authoring/routes/project/amends/lib/amends-content"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"

export function AuthoringRichTextReadOnly({
    content,
    emptyLabel = "No content yet.",
    dataCy = "authoring-rich-text-readonly",
}) {
    const isEmpty = !hasAmendsContent(content)
    const sanitizedHtml = sanitizeAmendsHtml(content)

    return (
        <If truthy={isEmpty}>
            <Typography variant="body2" sx={{ color: "text.secondary" }} data-cy={`${dataCy}-empty`}>
                {emptyLabel}
            </Typography>
            <Else>
                <Box
                    data-cy={dataCy}
                    sx={{ "& p": { m: 0 }, "& p + p": { mt: 1 } }}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }} // sanitized by sanitizeAmendsHtml above
                />
            </Else>
        </If>
    )
}
